import gql from 'graphql-tag';

export default gql`
  query referralAwaitingFirstOrder {
    referralAwaitingFirstOrder {
      referralId
      referrerId
      refereeId
      referrerName
      refereeName
      referralCode
      registeredAt
      status
      note
      hasPurchasedFirstOrder
      voucher
    }
  }
`;
